/* Configured-safe cart picture for the Liberty / AMSEC / Browning configurators.
   The Meta Variant Builder app block adds the configured line with its own fetch to /cart/add.js and never sends a
   picture, so the cart showed the generic placeholder photo. This adds the hero stack the shopper is looking at
   (body photo + visible overlays, in stacking order) to that request as the line property _fk_layers
   ("<w>x<h>|<cdn base>|<file>,<file>,..."), the same format Fort Knox uses, so snippets/fk-cart-layers.liquid draws
   it in the cart page and drawer. Fails safe: any problem leaves the request exactly as the app block built it. */
(function () {
  if (window.__cfgCartImagePatch) return;
  window.__cfgCartImagePatch = true;

  function heroStack() {
    var body = null, overlays = [];
    var lib = document.getElementById('lbc-hero-img');
    var brc = document.getElementById('brc-hero-img');
    if (brc) {
      body = brc;
      overlays = ['brc-ov-comp', 'brc-ov-scene', 'brc-ov-lock'].map(function (id) { return document.getElementById(id); }).filter(function (el) { return el && !el.hidden && el.getAttribute('src'); });
    } else if (document.querySelector('.lc__hero-body')) {
      body = document.querySelector('.lc__hero-body');
      overlays = Array.prototype.slice.call(document.querySelectorAll('.lc__hero-overlay.is-visible')).filter(function (el) { return el.getAttribute('src'); });
    } else if (lib) {
      body = lib;
    }
    if (!body || !body.getAttribute('src')) return null;
    return { body: body, overlays: overlays };
  }

  function layerProperty() {
    try {
      var s = heroStack();
      if (!s) return null;
      var w = s.body.naturalWidth, h = s.body.naturalHeight;
      if (!w || !h) return null;
      var urls = [s.body.currentSrc || s.body.src].concat(s.overlays.map(function (el) { return el.currentSrc || el.src; }));
      if (urls.some(function (u) { return u.indexOf('https://cdn.shopify.com/') !== 0; })) return null;
      // longest shared folder of all the layers (body photo and overlays can sit in different CDN folders)
      var base = urls[0].slice(0, urls[0].lastIndexOf('/') + 1);
      urls.forEach(function (u) { while (base.length > 'https://cdn.shopify.com/'.length && u.indexOf(base) !== 0) base = base.slice(0, base.lastIndexOf('/', base.length - 2) + 1); });
      var files = urls.map(function (u) { return u.slice(base.length); });
      if (files.some(function (f) { return !f || /[|,]/.test(f); })) return null;
      return w + 'x' + h + '|' + base + '|' + files.join(',');
    } catch (err) { return null; }
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        if (body && Array.isArray(body.items)) {
          var layers = null, changed = false;
          body.items.forEach(function (it) {
            var pr = it && it.properties;
            if (pr && (pr._configurator === 'true' || pr._configuredProduct === 'true') && !pr._fk_layers) {
              if (layers === null) layers = layerProperty() || '';
              if (layers) { pr._fk_layers = layers; changed = true; }
            }
          });
          if (changed) init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      }
    } catch (err) { /* leave the request untouched */ }
    return origFetch.call(this, input, init);
  };
})();
